export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGOUT = "LOGOUT";
export const SAVE_BRANDS = "SAVE_BRANDS";
export const SAVE_FAVORITE_BRANDS = "SAVE_FAVORITE_BRANDS";
export const SAVE_CUSTOM_RECRUIT_CATEGORY = "SAVE_CUSTOM_RECRUIT_CATEGORY";
export const SAVE_FORMS = "SAVE_FORMS";
export const SAVE_HOUSEHOLD = "SAVE_HOUSEHOLD";
export const SAVE_OCCASION = "SAVE_OCCASION";
export const SAVE_PARTICIPANT_SEGMENT = "SAVE_PARTICIPANT_SEGMENT";
export const CLEAR_DASHBOARD_STATES = "CLEAR_DASHBOARD_STATES";
export const SAVE_DATE_RANGE = "SAVE_DATE_RANGE";
export const RESET_DATE_RANGE = "RESET_DATE_RANGE";
export const SAVE_END_DATE = "SAVE_END_DATE";
export const RESET_END_DATE = "RESET_END_DATE";
export const SAVE_DASHBOARD_FILTER = "SAVE_DASHBOARD_FILTER";
export const SELECTED_CLIENT_NAME = "SELECTED_CLIENT_NAME";

export const SET_STUDY_ID = "SET_STUDY_ID";
export const RESET_STUDY_ID = "RESET_STUDY_ID";

export const SET_SESSION_ID = "SET_SESSION_ID";
export const RESET_SESSION_ID = "RESET_SESSION_ID";

export const SET_SESSION_CODE = "SET_SESSION_CODE";
export const RESET_SESSION_CODE = "RESET_SESSION_CODE";

export const SET_SELECTED_SURVEY_CATEGORY = "SET_SELECTED_SURVEY_CATEGORY";
export const RESET_SELECTED_SURVEY_CATEGORY = "RESET_SELECTED_SURVEY_CATEGORY";

export const APP_CONSTANT = {
  CATEGORY_LABEL: "Syndicated Category Benchmark",
  CATEGORY_VALUE: "Syndicated Category Benchmark",
};

export const getAppConstantCategoryValue = (isRecruitCategory = false) => {
  return isRecruitCategory
    ? "Custom Recruit Average"
    : "Syndicated Category Benchmark";
};

export const PROJECT_ID = "8502";
export const SECRET_KEY = "B6m7X!d3p@N#KqT^Zr$oG2%Lkv&uWyC8D9aY4JhQ5";

export const SP_CLIENT_ID_DEV = "1255";
export const SP_CLIENT_ID_STAGE = "1348";
export const SP_CLIENT_ID_LIVE = "1598";

export const PROJECT_PANEL = {
  SMART_PANEL: "smart_panel",
  TEST_PANEL: "test_panel",
};

export const INDEX_SCORE_INDICATOR = {
  GREEN_TEXT_VALUE: 120,
  GREY_TEXT_MIN_VALUE: 80,
  GREY_TEXT_MAX_VALUE: 120,
  RED_TEXT_VALUE: 80,
};

export const BASE_SIZE_MIN_VALUE = 35;
export const BASE_SIZE_MID_VALUE = "35-49";
export const SURVEY_BASE_SIZE_MIN_VALUE = 100;
export const SURVEY_BASE_SIZE_MID_VALUE = "100-150";
export const COMMON_PAGE_BOTTOM_TEXT = "Sample size falls below n=50";

export const getDefaultColumns = (isCustomRecruitCategory = false) =>
  Array.from({ length: 5 }, (_, i) => ({
    value: ``,
    selectedComparisons:
      i === 0 ? [getAppConstantCategoryValue(isCustomRecruitCategory)] : [],
    filterVal: "",
    colComparisonOptions: [],
    isColumnEditMode: false,
    columnEditVal: "",
    unCheckedCRCategories: [],
  }));

export const genDefAnswerOptions = (optionsData = []) => {
  if (optionsData?.length > 0) {
    const optionsArrData = JSON.parse(optionsData);
    return Array.from(
      { length: optionsArrData.length > 6 ? optionsArrData.length : 6 },
      (_, i) => ({
        label: optionsArrData[i] ? optionsArrData[i] : `Option ${i + 1}`,
        value: optionsArrData[i]
          ? optionsArrData[i]
          : i === 0 || i === 1
            ? `Option ${i + 1}`
            : "",
        isOptional: i === 0 || i === 1 ? false : true,
        isError: false,
        errormsg: "",
      }),
    );
  } else {
    return Array.from({ length: 6 }, (_, i) => ({
      label: `Option ${i + 1}`,
      value: i === 0 || i === 1 ? `Option ${i + 1}` : "",
      isOptional: i === 0 || i === 1 ? false : true,
      isError: false,
      errormsg: "",
    }));
  }
};

export const toSentenceCase = (str) => {
  if (!str) return "";
  str = str.trim(); // remove leading/trailing whitespace
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const excelExportSheetheader = (keyValue) => {
  if (keyValue === "weekpartData") {
    return "WEEK PART - % of  Uses";
  }
  if (keyValue === "timeOfDayData") {
    return "TIME OF DAY - % of  Uses";
  }
  if (keyValue === "occasionsData") {
    return "OCCASIONS - % of Survey Responses";
  }
  if (keyValue === "needsData") {
    return "NEEDS (ALL) - % of Survey Responses";
  } else {
    return keyValue;
  }
};

export const subNumCountingCapital = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "AA",
  "AB",
  "AC",
  "AD",
  "AE",
  "AF",
  "AG",
  "AH",
  "AI",
  "AJ",
  "AK",
  "AL",
  "AM",
  "AN",
  "AO",
  "AP",
  "AQ",
  "AR",
  "AS",
  "AT",
  "AU",
  "AV",
  "AW",
  "AX",
  "AY",
  "AZ",
  "BA",
  "BB",
  "BC",
  "BD",
  "BE",
  "BF",
  "BG",
  "BH",
  "BI",
  "BJ",
  "BK",
  "BL",
  "BM",
  "BN",
  "BO",
  "BP",
  "BQ",
  "BR",
  "BS",
  "BT",
  "BU",
  "BV",
  "BW",
  "BX",
  "BY",
  "BZ",
  "CA",
  "CB",
  "CC",
  "CD",
  "CE",
  "CF",
  "CG",
  "CH",
  "CI",
  "CJ",
  "CK",
  "CL",
  "CM",
  "CN",
  "CO",
  "CP",
  "CQ",
  "CR",
  "CS",
  "CT",
  "CU",
  "CV",
  "CW",
  "CX",
  "CY",
  "CZ",
];
export const valueBrands = [
  "COMET",
  "FORMULA 409",
  "GREAT VALUE",
  "HEB",
  "LA'S TOTALLY AWESOME",
  "PINE GLO",
  "PLEDGE",
  "PRIVATE LABEL",
  "RADIANCE",
  "SIMPLE GREEN",
  "up&up",
];
export const mainstreamBrands = [
  "CLOROX",
  "FANTASTIK",
  "LYSOL",
  "MICROBAN",
  "MR. CLEAN",
  "ZEP",
];
export const ecoNaturalBrands = [
  "BETTER LIFE",
  "CLEANCULT",
  "ECOS",
  "METHOD",
  "MRS. MEYER'S",
  "PURACY",
  "SEVENTH GENERATION",
];

export const subNumCounting = [
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
];

export const TQDurations = [
  { name: "15 sec", value: 15 },
  { name: "30 sec", value: 30 },
  { name: "45 sec", value: 45 },
  { name: "1 min", value: 60 },
  { name: "1.5 min", value: 90 },
  { name: "2 mins", value: 120 },
  { name: "2.5 mins", value: 150 },
  { name: "3 mins", value: 180 },
  { name: "4 mins", value: 240 },
  { name: "5 mins", value: 300 },
];

export const AnswerTypeOptions = [
  { name: "Text", value: "text" },
  { name: "Audio", value: "audio" },
  { name: "Number", value: "number" },
  // { name: "Time", value: "time" },
];

export const AddQuesSkeleton = (surveyType = "") => {
  return {
    quesDuration: 60,
    questionName: "",
    selectedQuestionOption: "open_ended_question",
    isError: false,
    errormsg: "",
    open_ended_question: {
      instructions:
        surveyType === "text"
          ? "Please explain in detail"
          : "Please explain verbally",
      isInstructionError: false,
      instructionErrormsg: "",
      answerTypeError: "",
      answerType: {
        selectedType: "text",
        selectedValue: 1,
      },
    },
    multiple_choice_single_select: {
      options: genDefAnswerOptions(),
      instructions:
        surveyType === "text"
          ? "Please select one option"
          : "Please explain verbally",
      isInstructionError: false,
      instructionErrormsg: "",
      randomizeAnsOpt: null,
      isBulkAdd: false,
      bulkAddText: "",
    },
    multiple_choice_multi_select: {
      options: genDefAnswerOptions(),
      instructions:
        surveyType === "text"
          ? "Please select all that apply"
          : "Please explain verbally",
      isInstructionError: false,
      instructionErrormsg: "",
      randomizeAnsOpt: null,
      isBulkAdd: false,
      bulkAddText: "",
    },
    rating_question: {
      instructions: "With 5 being the best",
      isInstructionError: false,
      instructionErrormsg: "",
      selectedScale: "5",
    },
    ranking_question: {
      options: genDefAnswerOptions(),
      instructions: "Tap on the options to set your preferred order",
      isInstructionError: false,
      instructionErrormsg: "",
      isBulkAdd: false,
      bulkAddText: "",
    },
    type: "question",
  };
};
export const AddTaskSkeleton = (surveyType = "") => {
  return {
    type: "task",
    isSelected: false,
    taskName: "",
    selectedTaskOption: "general",
    selectedStimuliType: "photo",
    instructions: "Tap on the thumbnail to view in full screen",
    selectedUploadPhotoType: "upload_photo",
    uploadPhotoVideoInstructions:
      "Please upload photos(s) using the button provided",
    uploadPhotoVideoInstructionsErr: "",
    selectedCaptureType: "capture_photo",
    captureCameraPosition: "0",
    captureInstructions: "Please take photo(s) using the button provided",
    captureInstructionsErr: "",
    screenCaptureInstructions: "Please take photo(s) using the button provided",
    screenCaptureInstructionsErr: "",
    barcodeInstructions: "Please take photo(s) using the button provided",
    barcodeInstructionsErr: "",
    subTaskQues: [],
    taskDuration: surveyType === "text" ? 30 : 60,
    skipLogic: [],
    isError: false,
    errormsg: "",
    photoUrl: "",
    videoThumbnailUrl: "",
    videoUrl: "",
    stimuliInstructionErrormsg: "",
    imgUploadErr: "",
    imgFile: null,
    isImageUploading: false,
    isImageUploaded: false,
    videoUploadErr: "",
    videoThumbUploadErr: "",
    videoFile: null,
    isVideoUploading: false,
    isVideoUploaded: false,
    videoThumbnailFile: null,
    isVideoThumbUploading: false,
    isVideoThumbUploaded: false,
  };
};
export const expectedXmotLength = [
  { name: "1", value: 1 },
  { name: "2", value: 2 },
  { name: "3", value: 3 },
  { name: "4", value: 4 },
  { name: "5", value: 5 },
  { name: "6", value: 6 },
  { name: "7", value: 7 },
  { name: "8", value: 8 },
  { name: "9", value: 9 },
  { name: "10", value: 10 },
  { name: "15", value: 15 },
  { name: "20", value: 20 },
  { name: "30", value: 30 },
  { name: "45", value: 45 },
  { name: "60", value: 60 },
  { name: "75", value: 75 },
  { name: "90", value: 90 },
  { name: "105", value: 105 },
  { name: "120", value: 120 },
];

// Function to calculate total time in minutes and seconds
export const calculateTotalTime = (selectedDurations) => {
  let totalSeconds = 0;
  // Convert each selected duration to seconds and sum them up
  selectedDurations.forEach((duration) => {
    const seconds = Number(duration) || 0;
    // totalSeconds += convertToSeconds(duration);
    totalSeconds += seconds;
  });

  // Convert total seconds to minutes and seconds
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  return { minutes, seconds, totalSeconds };
};

// Function to convert time strings to seconds
export const convertToSeconds = (duration) => {
  const parts = duration.split(" ");
  if (parts[1] === "sec") {
    return parseInt(parts[0], 10);
  } else if (parts[1] === "min" || parts[1] === "mins") {
    return parseFloat(parts[0]) * 60;
  }
  return 0;
};

export const reminderType = [
  { name: "Every", code: 2 },
  { name: "Once", code: 1 },
];

export const everyReminderTypeUnit = [{ name: "Hours", code: 1 }];

export const onceReminderTypeUnit = [
  { name: "Hours", code: 1 },
  { name: "Minutes", code: 2 },
];

export function random32BitBinary() {
  const array = new Uint32Array(1);
  crypto.getRandomValues(array);
  return array[0].toString(2).padStart(32, "0");
}

export const toMinuteValue = ({ minutes, seconds }) => {
  const totalMinutes = minutes + seconds / 60;
  return totalMinutes ? totalMinutes : 0;
};

// Function to calculate total time in minutes and seconds
export const getExpectedStringTime = (durationSeconds) => {
  const totalSeconds = Number(durationSeconds) || 0;
  // Convert total seconds to minutes and seconds
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  return { minutes, seconds };
};

export const perParticipantOptions = [
  { name: "Sent", code: 1 },
  // { name: "Completed", code: 2 },
];

export const AVERAGE_WEEKLY_FREQUENCY_TEXT = "Average Weekly Frequency";

export const ExtractAnswerOptionsValues = {
  selectedOption: 1,
  nonSelectedOptions: 2,
  allOptions: 3,
};

export const TargetQuestionTypeValues = {
  singleSelect: "multiple_choice_single_select",
  multiSelect: "multiple_choice_multi_select",
  ranking: "ranking_question",
};
export const surveyTQData = [
  {
    user_id: 8153,
    responses: [
      {
        user_id: "3094",
        task_name: "Tell us a little about yourself:",
        question_title: "What is your first name and where do you live?",
        transcript:
          "All right a little bit about myself first name. So my name is Denzel and I currently live in Gilbert Arizona, which is essentially a suburb of Phoenix. I'm originally from New Jersey, but I moved out here about nine years ago. I live at home with my wife and our dog haiku.",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name: "Tell us a little about yourself:",
        question_title: "How old are you?",
        transcript: "I'm currently 32 years old birthday is in November.",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name: "Tell us a little about yourself:",
        question_title:
          "How do you spend a typical day? (pick one and tell us a little about it verbally)",
        transcript:
          "I currently work full-time. So that's where I typically spend my day. I would say I'm about a 40 to 50 hour per week type of individual.",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name: "Tell us a little about yourself:",
        question_title:
          "Are you sheltering in place right now? (pick one and tell us a little about it verbally)",
        transcript:
          "Sheltering in place, I would say I'm somewhat trying to limit the amount that I go out right now, you know mainly because of covid Arizona's actually now like one of the new hot spots, so I'd rather just be safe than sorry and I think that's the main reason why you know right now I'm going out for Essentials. I actually go to work as part of like a rotating crew once every two weeks and then I go to work out at the gym. So those are pretty much the three areas that I do, but when I do my shopping Thing I try to do it all at once, you know hit five different stores at once instead of kind of going periodically throughout the week, which I normally do.",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name: "Tell us about who you share your home with:",
        question_title:
          "How would you best describe your current living situation?",
        transcript:
          "So I live with my spouse Janna and our dog Haiku. So we are my wife and I are married two years as of yesterday. It was our anniversary night and then our dog Haiku which was we adopted from the shelter pretty much about a month after we moved into our home. So yeah, we he basically he's our he's our kid per se pretty much treating him like a child doing everything as much as possible with him.",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      [],
      {
        user_id: "3094",
        task_name: "Tell us about who you share your home with:",
        question_title:
          "Do you have any of the following pets that live inside your home?",
        transcript: "Yes, we do have the one dog haiku.",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name: "Tell us about your home:",
        question_title: "What best describes where you live?",
        transcript:
          "So it's either going to be a day in the pool for me as I work remote or it's going to be a day under the AC in the living room hanging out.",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name: "Tell us about your home:",
        sq_question_id: "53146",
        question_type: "option",
        question_title: "Do you rent or own?",
        transcript: "And it is a two-story house that we have here.",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name: "Tell us about your home:",
        question_title:
          "What is the approximate size of your home in square feet?",
        transcript: "Seems like it's stopping.",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name: "",
        question_title: "How would you describe the cooking done in your home?",
        transcript:
          "It's like it's stuck. Okay, so seem like got a little stuck before but yeah, we live in a two-story house 3-bedroom 3-bath with a pool. And we actually we own our home we purchased it once we got married a couple of years ago. Approximate square footage so we're a little over 2000 square feet in this particular home. I would say that we cook homemade meals frequently. It's for us. It's kind of based on health. I would say my wife and I are both pretty big on health. My wife is actually training for a fitness competition right now. It was her New Year's goal. And for me kind of health is always been important for me because of family health issues. I've kind of always been an athlete. So I've always wanted to sustain and maintain that you know that figure that body that the healthy lifestyle per se, you know, so I think for us we do",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name: "",
        question_title:
          "Which of the statements below best describes the floors in your home?",
        av_id: "239831",
        transcript:
          "a lot of cooking at home, you know, Sometimes obviously gets boring and tiring. Sometimes we cook just a typical boring grilled chicken and asparagus or broccoli but usually are take out night is Friday. We don't do any cooking on Fridays and then we may or may not do takeout on a Saturday evening as well. If we really have long weeks and don't feel like it in terms of prepared meals or like freezer meals. We met by one or two from Trader Joe's and then kind of just save them for you know throughout the weeks when we really don't feel like cooking. So they're kind of like our emergency stash, but we don't",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name: "",
        question_title:
          "Which of the following methods best describes how you typically clean your home? (pick one and tell us more about it verbally)",
        transcript:
          "really actively shop too much for frozen or already prepared meals. Let's see describes the floors in your home. I have probably about equal amounts of hard floors and carpeting. So pretty much all of our downstairs are hardwood floors / tile. We don't have any carpet downstairs. We just have a throw rug is the only thing and then upstairs is actually all carpeting so our stairs to go up to the second level is Carl carpeted and then each room upstairs or So I definitely say we're like a 50/50 split. Typically clean your home. I am a I say I'm a",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name:
          "Take us on a tour of your home! Please talk us through it as you are showing us around.",
        question_title: "Let&#039;s start with the kitchen",
        transcript:
          "maintenance cleaner. I clean the stay on top of the mess. I would say my wife and I basically clean actually like our clean videos every Saturday. So Saturday mornings, we take time to kind of rotate on Spaces, but we'll go through and clean the bathrooms the kitchen, you know the floors and mop just to kind of stay on top of so they don't get extremely dirty, you know, not every week. We're doing a deep deep dive of a scrub, you know in terms of you know, five six hours. I'm cleaning but I would say each week. We definitely spend at least, you know on a Saturday at least two to two and a half hours, you know doing some sort of cleaning vacuuming mopping and that sort of thing. Okay, so starting with the kitchen. So this is actually our kitchen now I'll back up so you can kind of see the layout. So this is our kitchen. We've got a nice little Nook where we kind of just hang out and sit then we expand into the actual kitchen space are frigerator. We've got our island in the Middle where most of my prepping is done in terms of cooking. We've got our gas stove as you see with the overhead microwave. All of our cabinets for all of our many different supplies spices bowls pots pans that sort of thing we scour over to our spice rack and blender and toaster and some of our other areas over to our sink. We ended up getting one of those new wireless touch sinks. So we just installed that about a week",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name:
          "Take us on a tour of your home! Please talk us through it as you are showing us around.",
        question_title: "Now show us the living room",
        transcript:
          "or two ago got our dishwasher built in right there and then more counter space and then here you'll see is where a lot of our pots and pans are Underneath for storage. It's our kitchen table. So that's where we usually sit for breakfast. We've got this fun little menu thing. So when we host the we always put up what we're going to be feeding our guests and then our to his and hers chairs where we usually sit to kind of relax and recover. Then you scan over this way. You will go into our pantry. So it's a walk-in Pantry double sided with all different products and items for us to have and use on a daily basis so that Is our kitchen. And then going into the living room. So right basically other side of the kitchen is our living room. So you'll see here. We've got an L-shaped couch super comfy. Usually where the dog is hanging out during the day as you can see a lot of the wear and tear on the couches from his paws little coffee table a little singular chair there and then our TV set up so we've got",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name:
          "Take us on a tour of your home! Please talk us through it as you are showing us around.",
        question_title: "Next show us your bathroom",
        transcript:
          "so no surround system on a flat screen TV a couple video game systems and that sort of thing. So this is really just my relaxing areas. You see I've got the fan going over overhead. What's also really nice is that when I open the blinds at actually looks right out into the pool area. So you can see kind of our outdoor. I guess mini Resort style area if you will to lounge chairs to Upright chairs and then our two grills outside. So this is really a my favorite spots are usually the living room for me and then also the pool area when it's not super super hot and then that expands to to kind of like our front door and then also shows to our steps. Going up so I'm going up the stairs quickly. I'll just show you this is our spare room. It's actually a fourth bedroom, but we had plans of converting it into an office before covid and it never happened and now we're kind of regretting it. So it actually is four bedrooms three baths. This is the downstairs spared one of the spare bathrooms. And then this is the laundry room along with our little guy haikus sleeping right now, and he's wondering why I'm turning the lights on on them, but that's our laundry room a couple of Closet spaces. So now you'll see tiles with everything down here the one throw rug and now we're going up the stairs as you see carpeted as I was showing and then we'll head",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name:
          "Take us on a tour of your home! Please talk us through it as you are showing us around.",
        question_title:
          "Are there any other rooms where you spend lots of time? Please show us.",
        transcript:
          "master bedroom and bathroom excuse the bed. It's probably not made up because I'm not a big bed makeup person. But yeah, this is our bed. This is our room. So we've got our big TV and then it opens up into our main bathroom with his and her sinks. It's tub/shower combination here just art toilet area is in here and obviously the big mirror and then the walk-in closet my wife stuff and then my stuff up heads shoes sneakers hats all sorts of things. So that's kind of how the layout of the main bathroom looks. Any other rooms where you spend lots of time? No, I honestly I honestly don't spend a lot of time in my bedroom most of the time for me. It's down in the living room. So this is kind of just",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name:
          "Take us on a tour of your home! Please talk us through it as you are showing us around.",
        question_title: "What room&#47;s do you love or hate?",
        transcript:
          "an overhead. So just coming out of our room. You see the third bathroom there as well as the two final rooms. It's just so you can briefly see them. That's one room here and then we've got one more room here just had guests last weekend. So we're in the midst of cleaning. The sheets but this as you see here is really the main spot that I'm in you'll see my laptop down there now in the pillow. I'm kind of working remote from the couch today and I'd like to be in that area just because the couch is super comfy. It's a inviting relaxing atmosphere, you know, and it I like it because I have the fan and then I also have the air conditioning in that space. What rooms do you love or hate? So I would actually say the two spare rooms. I kind of hate at the moment mainly just because I almost wish this was the three-bedroom home and they could expand the room in a sense the room seems a little tight, you know, and right now we don't have any kids. So it's not as big of a burden but we're just kind of concerned obviously with this particular house when we do have kids and they get older and they need workspace and a desk in the room and that sort of thing. It seems very difficult to have that you know,",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name:
          "Take us on a tour of your home! Please talk us through it as you are showing us around.",
        question_title:
          "Is there anything else you would like to share about your home?",
        transcript:
          "and then some of the some of the things are kind of older in here, you know, like the mirror closet look kind of is kind of a bit dated I feel you know, so we've tried to incorporate some new items in here. But I yeah just the the size of the room is not super ideal, but I think it does the job. I mean we've had adult stay in there and say it's been great sleeps. So that's not an issue. Definitely. The spare bathroom is a room that we hate and we want to get renovated. We hate the bathroom Fitters and this is one of those typical bathroom fitter setups and that we really really don't like so we're looking to try to get that renovated. So I would definitely say that's play everyone places. I we hate and a sense love I would definitely say it would be our living room area. It's just because it's so convenient. We've got the surround sound and the music going when we want we can watch TV and then the other I guess not necessarily a row. Umm, but I mean outside I'll show you is one thing that we love just because we've got the grill you got the covering underneath with the fans so you don't have to be in direct sun and then you can come out you've got the grills. We've got the two lounge chairs. We've got the upright tall chairs for eating and then we've got our pool area. This is what I love because that flow to you see right there is usually got my name on it, especially on the weekends with like a cocktail or something and then my wife loves it out here because she loves the plan. So you see a lot of different flowers which can be challenging out here in Arizona because the sun is so intense majority of the year and the heat, but she does a good job of managing and doing her early morning watering and late evening watering to keep them healthy. Is there anything else you'd like to share about your home? Um overall? I just I think we're happy with our home. We do like it. We enjoy it. We do think as we get kids we would need to expand. I think this home is very good for you know, two people and a dog and maybe one child, but once if we were to have more than one or a child in a dog, it may become a little tighter, but I really like kind of the openness and the flow of it, you know, and how everything is kind of separated in a It's we really do love the kitchen actually as well. And I think that's mainly just because we like to cook and growing up. Neither one of us grew up with homes that had Island. So it was really",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
    ],
  },
  {
    user_id: 8154,
    responses: [
      {
        user_id: "3094",
        task_name: "Tell us a little about yourself:",
        question_title: "What is your first name and where do you live?",
        transcript:
          "All right a little bit about myself first name. So my name is Denzel and I currently live in Gilbert Arizona, which is essentially a suburb of Phoenix. I'm originally from New Jersey, but I moved out here about nine years ago. I live at home with my wife and our dog haiku.",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name: "Tell us a little about yourself:",
        question_title: "How old are you?",
        transcript: "I'm currently 32 years old birthday is in November.",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name: "Tell us a little about yourself:",
        question_title:
          "How do you spend a typical day? (pick one and tell us a little about it verbally)",
        transcript:
          "I currently work full-time. So that's where I typically spend my day. I would say I'm about a 40 to 50 hour per week type of individual.",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name: "Tell us a little about yourself:",
        question_title:
          "Are you sheltering in place right now? (pick one and tell us a little about it verbally)",
        transcript:
          "Sheltering in place, I would say I'm somewhat trying to limit the amount that I go out right now, you know mainly because of covid Arizona's actually now like one of the new hot spots, so I'd rather just be safe than sorry and I think that's the main reason why you know right now I'm going out for Essentials. I actually go to work as part of like a rotating crew once every two weeks and then I go to work out at the gym. So those are pretty much the three areas that I do, but when I do my shopping Thing I try to do it all at once, you know hit five different stores at once instead of kind of going periodically throughout the week, which I normally do.",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name: "Tell us about who you share your home with:",
        question_title:
          "How would you best describe your current living situation?",
        transcript:
          "So I live with my spouse Janna and our dog Haiku. So we are my wife and I are married two years as of yesterday. It was our anniversary night and then our dog Haiku which was we adopted from the shelter pretty much about a month after we moved into our home. So yeah, we he basically he's our he's our kid per se pretty much treating him like a child doing everything as much as possible with him.",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      [],
      {
        user_id: "3094",
        task_name: "Tell us about who you share your home with:",
        question_title:
          "Do you have any of the following pets that live inside your home?",
        transcript: "Yes, we do have the one dog haiku.",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name: "Tell us about your home:",
        question_title: "What best describes where you live?",
        transcript:
          "So it's either going to be a day in the pool for me as I work remote or it's going to be a day under the AC in the living room hanging out.",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name: "Tell us about your home:",
        sq_question_id: "53146",
        question_type: "option",
        question_title: "Do you rent or own?",
        transcript: "And it is a two-story house that we have here.",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name: "Tell us about your home:",
        question_title:
          "What is the approximate size of your home in square feet?",
        transcript: "Seems like it's stopping.",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name: "",
        question_title: "How would you describe the cooking done in your home?",
        transcript:
          "It's like it's stuck. Okay, so seem like got a little stuck before but yeah, we live in a two-story house 3-bedroom 3-bath with a pool. And we actually we own our home we purchased it once we got married a couple of years ago. Approximate square footage so we're a little over 2000 square feet in this particular home. I would say that we cook homemade meals frequently. It's for us. It's kind of based on health. I would say my wife and I are both pretty big on health. My wife is actually training for a fitness competition right now. It was her New Year's goal. And for me kind of health is always been important for me because of family health issues. I've kind of always been an athlete. So I've always wanted to sustain and maintain that you know that figure that body that the healthy lifestyle per se, you know, so I think for us we do",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name: "",
        question_title:
          "Which of the statements below best describes the floors in your home?",
        av_id: "239831",
        transcript:
          "a lot of cooking at home, you know, Sometimes obviously gets boring and tiring. Sometimes we cook just a typical boring grilled chicken and asparagus or broccoli but usually are take out night is Friday. We don't do any cooking on Fridays and then we may or may not do takeout on a Saturday evening as well. If we really have long weeks and don't feel like it in terms of prepared meals or like freezer meals. We met by one or two from Trader Joe's and then kind of just save them for you know throughout the weeks when we really don't feel like cooking. So they're kind of like our emergency stash, but we don't",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name: "",
        question_title:
          "Which of the following methods best describes how you typically clean your home? (pick one and tell us more about it verbally)",
        transcript:
          "really actively shop too much for frozen or already prepared meals. Let's see describes the floors in your home. I have probably about equal amounts of hard floors and carpeting. So pretty much all of our downstairs are hardwood floors / tile. We don't have any carpet downstairs. We just have a throw rug is the only thing and then upstairs is actually all carpeting so our stairs to go up to the second level is Carl carpeted and then each room upstairs or So I definitely say we're like a 50/50 split. Typically clean your home. I am a I say I'm a",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name:
          "Take us on a tour of your home! Please talk us through it as you are showing us around.",
        question_title: "Let&#039;s start with the kitchen",
        transcript:
          "maintenance cleaner. I clean the stay on top of the mess. I would say my wife and I basically clean actually like our clean videos every Saturday. So Saturday mornings, we take time to kind of rotate on Spaces, but we'll go through and clean the bathrooms the kitchen, you know the floors and mop just to kind of stay on top of so they don't get extremely dirty, you know, not every week. We're doing a deep deep dive of a scrub, you know in terms of you know, five six hours. I'm cleaning but I would say each week. We definitely spend at least, you know on a Saturday at least two to two and a half hours, you know doing some sort of cleaning vacuuming mopping and that sort of thing. Okay, so starting with the kitchen. So this is actually our kitchen now I'll back up so you can kind of see the layout. So this is our kitchen. We've got a nice little Nook where we kind of just hang out and sit then we expand into the actual kitchen space are frigerator. We've got our island in the Middle where most of my prepping is done in terms of cooking. We've got our gas stove as you see with the overhead microwave. All of our cabinets for all of our many different supplies spices bowls pots pans that sort of thing we scour over to our spice rack and blender and toaster and some of our other areas over to our sink. We ended up getting one of those new wireless touch sinks. So we just installed that about a week",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name:
          "Take us on a tour of your home! Please talk us through it as you are showing us around.",
        question_title: "Now show us the living room",
        transcript:
          "or two ago got our dishwasher built in right there and then more counter space and then here you'll see is where a lot of our pots and pans are Underneath for storage. It's our kitchen table. So that's where we usually sit for breakfast. We've got this fun little menu thing. So when we host the we always put up what we're going to be feeding our guests and then our to his and hers chairs where we usually sit to kind of relax and recover. Then you scan over this way. You will go into our pantry. So it's a walk-in Pantry double sided with all different products and items for us to have and use on a daily basis so that Is our kitchen. And then going into the living room. So right basically other side of the kitchen is our living room. So you'll see here. We've got an L-shaped couch super comfy. Usually where the dog is hanging out during the day as you can see a lot of the wear and tear on the couches from his paws little coffee table a little singular chair there and then our TV set up so we've got",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name:
          "Take us on a tour of your home! Please talk us through it as you are showing us around.",
        question_title: "Next show us your bathroom",
        transcript:
          "so no surround system on a flat screen TV a couple video game systems and that sort of thing. So this is really just my relaxing areas. You see I've got the fan going over overhead. What's also really nice is that when I open the blinds at actually looks right out into the pool area. So you can see kind of our outdoor. I guess mini Resort style area if you will to lounge chairs to Upright chairs and then our two grills outside. So this is really a my favorite spots are usually the living room for me and then also the pool area when it's not super super hot and then that expands to to kind of like our front door and then also shows to our steps. Going up so I'm going up the stairs quickly. I'll just show you this is our spare room. It's actually a fourth bedroom, but we had plans of converting it into an office before covid and it never happened and now we're kind of regretting it. So it actually is four bedrooms three baths. This is the downstairs spared one of the spare bathrooms. And then this is the laundry room along with our little guy haikus sleeping right now, and he's wondering why I'm turning the lights on on them, but that's our laundry room a couple of Closet spaces. So now you'll see tiles with everything down here the one throw rug and now we're going up the stairs as you see carpeted as I was showing and then we'll head",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name:
          "Take us on a tour of your home! Please talk us through it as you are showing us around.",
        question_title:
          "Are there any other rooms where you spend lots of time? Please show us.",
        transcript:
          "master bedroom and bathroom excuse the bed. It's probably not made up because I'm not a big bed makeup person. But yeah, this is our bed. This is our room. So we've got our big TV and then it opens up into our main bathroom with his and her sinks. It's tub/shower combination here just art toilet area is in here and obviously the big mirror and then the walk-in closet my wife stuff and then my stuff up heads shoes sneakers hats all sorts of things. So that's kind of how the layout of the main bathroom looks. Any other rooms where you spend lots of time? No, I honestly I honestly don't spend a lot of time in my bedroom most of the time for me. It's down in the living room. So this is kind of just",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name:
          "Take us on a tour of your home! Please talk us through it as you are showing us around.",
        question_title: "What room&#47;s do you love or hate?",
        transcript:
          "an overhead. So just coming out of our room. You see the third bathroom there as well as the two final rooms. It's just so you can briefly see them. That's one room here and then we've got one more room here just had guests last weekend. So we're in the midst of cleaning. The sheets but this as you see here is really the main spot that I'm in you'll see my laptop down there now in the pillow. I'm kind of working remote from the couch today and I'd like to be in that area just because the couch is super comfy. It's a inviting relaxing atmosphere, you know, and it I like it because I have the fan and then I also have the air conditioning in that space. What rooms do you love or hate? So I would actually say the two spare rooms. I kind of hate at the moment mainly just because I almost wish this was the three-bedroom home and they could expand the room in a sense the room seems a little tight, you know, and right now we don't have any kids. So it's not as big of a burden but we're just kind of concerned obviously with this particular house when we do have kids and they get older and they need workspace and a desk in the room and that sort of thing. It seems very difficult to have that you know,",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name:
          "Take us on a tour of your home! Please talk us through it as you are showing us around.",
        question_title:
          "Is there anything else you would like to share about your home?",
        transcript:
          "and then some of the some of the things are kind of older in here, you know, like the mirror closet look kind of is kind of a bit dated I feel you know, so we've tried to incorporate some new items in here. But I yeah just the the size of the room is not super ideal, but I think it does the job. I mean we've had adult stay in there and say it's been great sleeps. So that's not an issue. Definitely. The spare bathroom is a room that we hate and we want to get renovated. We hate the bathroom Fitters and this is one of those typical bathroom fitter setups and that we really really don't like so we're looking to try to get that renovated. So I would definitely say that's play everyone places. I we hate and a sense love I would definitely say it would be our living room area. It's just because it's so convenient. We've got the surround sound and the music going when we want we can watch TV and then the other I guess not necessarily a row. Umm, but I mean outside I'll show you is one thing that we love just because we've got the grill you got the covering underneath with the fans so you don't have to be in direct sun and then you can come out you've got the grills. We've got the two lounge chairs. We've got the upright tall chairs for eating and then we've got our pool area. This is what I love because that flow to you see right there is usually got my name on it, especially on the weekends with like a cocktail or something and then my wife loves it out here because she loves the plan. So you see a lot of different flowers which can be challenging out here in Arizona because the sun is so intense majority of the year and the heat, but she does a good job of managing and doing her early morning watering and late evening watering to keep them healthy. Is there anything else you'd like to share about your home? Um overall? I just I think we're happy with our home. We do like it. We enjoy it. We do think as we get kids we would need to expand. I think this home is very good for you know, two people and a dog and maybe one child, but once if we were to have more than one or a child in a dog, it may become a little tighter, but I really like kind of the openness and the flow of it, you know, and how everything is kind of separated in a It's we really do love the kitchen actually as well. And I think that's mainly just because we like to cook and growing up. Neither one of us grew up with homes that had Island. So it was really",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
    ],
  },
  {
    user_id: 8155,
    responses: [
      {
        user_id: "3094",
        task_name: "Tell us a little about yourself:",
        question_title: "What is your first name and where do you live?",
        transcript:
          "All right a little bit about myself first name. So my name is Denzel and I currently live in Gilbert Arizona, which is essentially a suburb of Phoenix. I'm originally from New Jersey, but I moved out here about nine years ago. I live at home with my wife and our dog haiku.",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name: "Tell us a little about yourself:",
        question_title: "How old are you?",
        transcript: "I'm currently 32 years old birthday is in November.",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name: "Tell us a little about yourself:",
        question_title:
          "How do you spend a typical day? (pick one and tell us a little about it verbally)",
        transcript:
          "I currently work full-time. So that's where I typically spend my day. I would say I'm about a 40 to 50 hour per week type of individual.",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name: "Tell us a little about yourself:",
        question_title:
          "Are you sheltering in place right now? (pick one and tell us a little about it verbally)",
        transcript:
          "Sheltering in place, I would say I'm somewhat trying to limit the amount that I go out right now, you know mainly because of covid Arizona's actually now like one of the new hot spots, so I'd rather just be safe than sorry and I think that's the main reason why you know right now I'm going out for Essentials. I actually go to work as part of like a rotating crew once every two weeks and then I go to work out at the gym. So those are pretty much the three areas that I do, but when I do my shopping Thing I try to do it all at once, you know hit five different stores at once instead of kind of going periodically throughout the week, which I normally do.",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name: "Tell us about who you share your home with:",
        question_title:
          "How would you best describe your current living situation?",
        transcript:
          "So I live with my spouse Janna and our dog Haiku. So we are my wife and I are married two years as of yesterday. It was our anniversary night and then our dog Haiku which was we adopted from the shelter pretty much about a month after we moved into our home. So yeah, we he basically he's our he's our kid per se pretty much treating him like a child doing everything as much as possible with him.",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      [],
      {
        user_id: "3094",
        task_name: "Tell us about who you share your home with:",
        question_title:
          "Do you have any of the following pets that live inside your home?",
        transcript: "Yes, we do have the one dog haiku.",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name: "Tell us about your home:",
        question_title: "What best describes where you live?",
        transcript:
          "So it's either going to be a day in the pool for me as I work remote or it's going to be a day under the AC in the living room hanging out.",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name: "Tell us about your home:",
        sq_question_id: "53146",
        question_type: "option",
        question_title: "Do you rent or own?",
        transcript: "And it is a two-story house that we have here.",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name: "Tell us about your home:",
        question_title:
          "What is the approximate size of your home in square feet?",
        transcript: "Seems like it's stopping.",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name: "",
        question_title: "How would you describe the cooking done in your home?",
        transcript:
          "It's like it's stuck. Okay, so seem like got a little stuck before but yeah, we live in a two-story house 3-bedroom 3-bath with a pool. And we actually we own our home we purchased it once we got married a couple of years ago. Approximate square footage so we're a little over 2000 square feet in this particular home. I would say that we cook homemade meals frequently. It's for us. It's kind of based on health. I would say my wife and I are both pretty big on health. My wife is actually training for a fitness competition right now. It was her New Year's goal. And for me kind of health is always been important for me because of family health issues. I've kind of always been an athlete. So I've always wanted to sustain and maintain that you know that figure that body that the healthy lifestyle per se, you know, so I think for us we do",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name: "",
        question_title:
          "Which of the statements below best describes the floors in your home?",
        av_id: "239831",
        transcript:
          "a lot of cooking at home, you know, Sometimes obviously gets boring and tiring. Sometimes we cook just a typical boring grilled chicken and asparagus or broccoli but usually are take out night is Friday. We don't do any cooking on Fridays and then we may or may not do takeout on a Saturday evening as well. If we really have long weeks and don't feel like it in terms of prepared meals or like freezer meals. We met by one or two from Trader Joe's and then kind of just save them for you know throughout the weeks when we really don't feel like cooking. So they're kind of like our emergency stash, but we don't",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name: "",
        question_title:
          "Which of the following methods best describes how you typically clean your home? (pick one and tell us more about it verbally)",
        transcript:
          "really actively shop too much for frozen or already prepared meals. Let's see describes the floors in your home. I have probably about equal amounts of hard floors and carpeting. So pretty much all of our downstairs are hardwood floors / tile. We don't have any carpet downstairs. We just have a throw rug is the only thing and then upstairs is actually all carpeting so our stairs to go up to the second level is Carl carpeted and then each room upstairs or So I definitely say we're like a 50/50 split. Typically clean your home. I am a I say I'm a",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name:
          "Take us on a tour of your home! Please talk us through it as you are showing us around.",
        question_title: "Let&#039;s start with the kitchen",
        transcript:
          "maintenance cleaner. I clean the stay on top of the mess. I would say my wife and I basically clean actually like our clean videos every Saturday. So Saturday mornings, we take time to kind of rotate on Spaces, but we'll go through and clean the bathrooms the kitchen, you know the floors and mop just to kind of stay on top of so they don't get extremely dirty, you know, not every week. We're doing a deep deep dive of a scrub, you know in terms of you know, five six hours. I'm cleaning but I would say each week. We definitely spend at least, you know on a Saturday at least two to two and a half hours, you know doing some sort of cleaning vacuuming mopping and that sort of thing. Okay, so starting with the kitchen. So this is actually our kitchen now I'll back up so you can kind of see the layout. So this is our kitchen. We've got a nice little Nook where we kind of just hang out and sit then we expand into the actual kitchen space are frigerator. We've got our island in the Middle where most of my prepping is done in terms of cooking. We've got our gas stove as you see with the overhead microwave. All of our cabinets for all of our many different supplies spices bowls pots pans that sort of thing we scour over to our spice rack and blender and toaster and some of our other areas over to our sink. We ended up getting one of those new wireless touch sinks. So we just installed that about a week",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name:
          "Take us on a tour of your home! Please talk us through it as you are showing us around.",
        question_title: "Now show us the living room",
        transcript:
          "or two ago got our dishwasher built in right there and then more counter space and then here you'll see is where a lot of our pots and pans are Underneath for storage. It's our kitchen table. So that's where we usually sit for breakfast. We've got this fun little menu thing. So when we host the we always put up what we're going to be feeding our guests and then our to his and hers chairs where we usually sit to kind of relax and recover. Then you scan over this way. You will go into our pantry. So it's a walk-in Pantry double sided with all different products and items for us to have and use on a daily basis so that Is our kitchen. And then going into the living room. So right basically other side of the kitchen is our living room. So you'll see here. We've got an L-shaped couch super comfy. Usually where the dog is hanging out during the day as you can see a lot of the wear and tear on the couches from his paws little coffee table a little singular chair there and then our TV set up so we've got",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name:
          "Take us on a tour of your home! Please talk us through it as you are showing us around.",
        question_title: "Next show us your bathroom",
        transcript:
          "so no surround system on a flat screen TV a couple video game systems and that sort of thing. So this is really just my relaxing areas. You see I've got the fan going over overhead. What's also really nice is that when I open the blinds at actually looks right out into the pool area. So you can see kind of our outdoor. I guess mini Resort style area if you will to lounge chairs to Upright chairs and then our two grills outside. So this is really a my favorite spots are usually the living room for me and then also the pool area when it's not super super hot and then that expands to to kind of like our front door and then also shows to our steps. Going up so I'm going up the stairs quickly. I'll just show you this is our spare room. It's actually a fourth bedroom, but we had plans of converting it into an office before covid and it never happened and now we're kind of regretting it. So it actually is four bedrooms three baths. This is the downstairs spared one of the spare bathrooms. And then this is the laundry room along with our little guy haikus sleeping right now, and he's wondering why I'm turning the lights on on them, but that's our laundry room a couple of Closet spaces. So now you'll see tiles with everything down here the one throw rug and now we're going up the stairs as you see carpeted as I was showing and then we'll head",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name:
          "Take us on a tour of your home! Please talk us through it as you are showing us around.",
        question_title:
          "Are there any other rooms where you spend lots of time? Please show us.",
        transcript:
          "master bedroom and bathroom excuse the bed. It's probably not made up because I'm not a big bed makeup person. But yeah, this is our bed. This is our room. So we've got our big TV and then it opens up into our main bathroom with his and her sinks. It's tub/shower combination here just art toilet area is in here and obviously the big mirror and then the walk-in closet my wife stuff and then my stuff up heads shoes sneakers hats all sorts of things. So that's kind of how the layout of the main bathroom looks. Any other rooms where you spend lots of time? No, I honestly I honestly don't spend a lot of time in my bedroom most of the time for me. It's down in the living room. So this is kind of just",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name:
          "Take us on a tour of your home! Please talk us through it as you are showing us around.",
        question_title: "What room&#47;s do you love or hate?",
        transcript:
          "an overhead. So just coming out of our room. You see the third bathroom there as well as the two final rooms. It's just so you can briefly see them. That's one room here and then we've got one more room here just had guests last weekend. So we're in the midst of cleaning. The sheets but this as you see here is really the main spot that I'm in you'll see my laptop down there now in the pillow. I'm kind of working remote from the couch today and I'd like to be in that area just because the couch is super comfy. It's a inviting relaxing atmosphere, you know, and it I like it because I have the fan and then I also have the air conditioning in that space. What rooms do you love or hate? So I would actually say the two spare rooms. I kind of hate at the moment mainly just because I almost wish this was the three-bedroom home and they could expand the room in a sense the room seems a little tight, you know, and right now we don't have any kids. So it's not as big of a burden but we're just kind of concerned obviously with this particular house when we do have kids and they get older and they need workspace and a desk in the room and that sort of thing. It seems very difficult to have that you know,",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
      {
        user_id: "3094",
        task_name:
          "Take us on a tour of your home! Please talk us through it as you are showing us around.",
        question_title:
          "Is there anything else you would like to share about your home?",
        transcript:
          "and then some of the some of the things are kind of older in here, you know, like the mirror closet look kind of is kind of a bit dated I feel you know, so we've tried to incorporate some new items in here. But I yeah just the the size of the room is not super ideal, but I think it does the job. I mean we've had adult stay in there and say it's been great sleeps. So that's not an issue. Definitely. The spare bathroom is a room that we hate and we want to get renovated. We hate the bathroom Fitters and this is one of those typical bathroom fitter setups and that we really really don't like so we're looking to try to get that renovated. So I would definitely say that's play everyone places. I we hate and a sense love I would definitely say it would be our living room area. It's just because it's so convenient. We've got the surround sound and the music going when we want we can watch TV and then the other I guess not necessarily a row. Umm, but I mean outside I'll show you is one thing that we love just because we've got the grill you got the covering underneath with the fans so you don't have to be in direct sun and then you can come out you've got the grills. We've got the two lounge chairs. We've got the upright tall chairs for eating and then we've got our pool area. This is what I love because that flow to you see right there is usually got my name on it, especially on the weekends with like a cocktail or something and then my wife loves it out here because she loves the plan. So you see a lot of different flowers which can be challenging out here in Arizona because the sun is so intense majority of the year and the heat, but she does a good job of managing and doing her early morning watering and late evening watering to keep them healthy. Is there anything else you'd like to share about your home? Um overall? I just I think we're happy with our home. We do like it. We enjoy it. We do think as we get kids we would need to expand. I think this home is very good for you know, two people and a dog and maybe one child, but once if we were to have more than one or a child in a dog, it may become a little tighter, but I really like kind of the openness and the flow of it, you know, and how everything is kind of separated in a It's we really do love the kitchen actually as well. And I think that's mainly just because we like to cook and growing up. Neither one of us grew up with homes that had Island. So it was really",
        photo_urls: "",
        video_urls:
          "https://stgmedia.qualsights.com/us/recordedSessions/GM-idYY5-1270-48783_720p.mp4",
      },
    ],
  },
];

export const transitionLengthOptions = [
  { name: "1", value: 1 },
  { name: "2", value: 2 },
  { name: "3", value: 3 },
  { name: "4", value: 4 },
  { name: "5", value: 5 },
];
